import React, { useEffect, useState } from "react";
import { getPackageCategory, getTourPackagePlanlist } from "./axios";
import SkeletonSliderComponent from "./SkeletonSliderComponent";
import { LazyLoadImage } from "react-lazy-load-image-component";
import moment from "moment";
import { Base64 } from "js-base64";
import {
  constant,
  guestCombinationSentence,
} from "./AdminPackageDetails/PackageShowcase/commonFunction";
import { cssUtils } from "./common";

const SliderComponent = ({ heading, viewAllClick }) => {
  const [categoryData, setCategoryData] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeCategory, setActiveCategory] = useState(0);
  const itemsPerSlide = window.innerWidth < 768 ? 1 : 4;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getPackageCategoryData = await getPackageCategory();

        if (Array.isArray(getPackageCategoryData)) {
          const finalCategory = getPackageCategoryData.filter(
            ({ package_count }) => parseInt(package_count) > 0
          );

          if (finalCategory.length) {
            setCategoryData(finalCategory);
            await fetchPackageData(finalCategory[0].id);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const fetchPackageData = async (categoryId = "") => {
    try {
      setIsLoading(true);
      const params = {
        defaultZonevalPackageVal: "seychelles",
        // dateSelected: "2025-01-12",
        privacy_type: 3,
        category_id: categoryId,
      };
      const response = await getTourPackagePlanlist(JSON.stringify(params));

      const data = Array.isArray(response) && response.length ? response : [];
      setPackageData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCategoryClick = (index, id) => {
    setActiveCategory(index);
    fetchPackageData(id);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev + itemsPerSlide < packageData.length ? prev + 1 : prev
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  return (
    <div
      className=" appendBottom20 superOfferSection  sticky-scroll"
      id="Offers_Listing"
    >
      <div className="container">
        <div className="SuperlandingCard" style={{ height: "auto" }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className={`fw-bold mb-2 ${cssUtils.leftBorder()}`}>
              {heading}
            </h3>
            {viewAllClick && (
              <button
                className="btn btn-primary btn-sm rounded-pill"
                onClick={viewAllClick}
              >
                View All
              </button>
            )}
          </div>

          <div
            className="nav-container"
            style={{
              overflowX: "auto", // Enable horizontal scrolling
              whiteSpace: "nowrap", // Prevent wrapping of tabs
              borderBottom: "2px solid #dee2e6",
            }}
          >
            <ul
              className="nav"
              style={{ display: "flex", flexWrap: "nowrap", padding: 0 }}
            >
              {categoryData
                .filter((x) => parseInt(x.package_count) > 0)
                .map(({ package_name, id, package_count }, index) => (
                  <li
                    key={index}
                    className="nav-item"
                    style={{ display: "inline-block" }}
                  >
                    <small
                      className={`nav-link fw-bold text-${
                        activeCategory === index ? "primary" : "dark"
                      }`}
                      onClick={() => handleCategoryClick(index, id)}
                      style={{
                        cursor: "pointer",
                        borderBottom:
                          activeCategory === index
                            ? "2px solid #007bff"
                            : "none", // Highlight active tab
                        padding: "5px 10px", // Adjust padding for better click area
                        display: "inline-block",
                        fontSize: 12,
                      }}
                    >
                      {`${package_name} (${package_count})`}
                    </small>
                  </li>
                ))}
            </ul>
          </div>

          {isLoading ? (
            <SkeletonSliderComponent />
          ) : (
            <div className="card-body position-relative">
              <button
                className="btn btn-dark position-absolute top-50 translate-middle-y"
                onClick={prevSlide}
                disabled={currentIndex === 0}
                style={{ zIndex: 10, left: -15 }}
              >
                ❮
              </button>

              <div className="overflow-hidden">
                <div
                  className="row flex-nowrap g-4"
                  style={{
                    transform: `translateX(-${
                      currentIndex * (100 / itemsPerSlide)
                    }%)`,
                    transition: "0.5s",
                  }}
                >
                  {packageData.length > 0 ? (
                    packageData.map(
                      (
                        {
                          id,
                          package_name,
                          location,
                          package_image,
                          no_days,
                          guest_combination,
                          selling_price,
                          discount_percentage,
                          price,
                          package_description,
                          // package_open_date,
                          package_close_date,
                          start_location,
                          start_date,
                          end_date,
                        },
                        index
                      ) => {
                        const guest = JSON.parse(guest_combination);
                        const guestCombination = guestCombinationSentence(
                          guest
                        );

                        const packageDescription = package_description
                          ? package_description
                              .replace(/<[^>]+>/g, "")
                              .substring(0, 50)
                          : "";

                        let startDate = moment(start_date);
                        let endDate = moment(end_date);
                        let diff = endDate.diff(startDate);
                        let diffDuration = moment.duration(diff);
                        let TotalDays = diffDuration.days();

                        let result = [];
                        const startDateNew = new Date(start_date);
                        const endDateNew = new Date(end_date);
                        const numberOfLocation = location.length;

                        // Calculate the total number of days in the range
                        const totalDays =
                          (endDateNew - startDateNew) / (1000 * 60 * 60 * 24);

                        // Divide the range into four equal parts
                        let daysPerPart = Math.floor(
                          totalDays / numberOfLocation
                        );
                        let reminder = totalDays % numberOfLocation;

                        // Initialize an array to store the results
                        const dividedRanges = [];

                        location.map((location, index) => {
                          let numberDay = "";

                          if (TotalDays % numberOfLocation == 0) {
                            numberDay = TotalDays / numberOfLocation;
                          } else {
                            numberDay = TotalDays % numberOfLocation;
                          }

                          let DateMain = [];
                          const partStartDate = new Date(startDateNew);
                          const partEndDate = new Date(partStartDate);
                          // Calculate the end date for the current part
                          partEndDate.setDate(
                            partEndDate.getDate() + daysPerPart
                          );
                          // If there's a reminder, distribute it across the parts
                          if (reminder > 0) {
                            partEndDate.setDate(partEndDate.getDate() + 1);
                            reminder--;
                          }
                          // Store the calculated part in the results array
                          let startDateNewData = moment(partStartDate);
                          let endDateNewData = moment(partEndDate);
                          let diffNewDataNew = endDateNewData.diff(
                            startDateNewData,
                            "days"
                          );
                          DateMain.push({
                            number: diffNewDataNew,
                            startDate: moment(partStartDate).format("Y-MM-DD"),
                            endDate: moment(partEndDate).format("Y-MM-DD"),
                            indexid: index,
                          });

                          dividedRanges.push({
                            number: diffNewDataNew,
                            startDate: moment(partStartDate).format("Y-MM-DD"),
                            endDate: moment(partEndDate).format("Y-MM-DD"),
                            indexid: index,
                          });
                          // Update the start date for the next part
                          startDateNew.setDate(partEndDate.getDate());

                          let newData = {
                            Id: location.location,
                            Location: { label: location.location },
                            name: diffNewDataNew,
                            range: DateMain,
                          };
                          result.push(newData);
                        });

                        const treeData = [
                          {
                            cat: JSON.parse(guest_combination),
                            Planname: `${location
                              .map((list) => JSON.stringify(list?.location))
                              .join(", ")} - (${moment(start_date).format(
                              "ddd, DD MMM Y"
                            )} - ${moment(end_date).format("ddd, DD MMM Y")})`,
                            range: [
                              { startDate: start_date, endDate: end_date },
                            ],
                            numberOfDay: no_days,
                            numberOfLocation: location.length,
                            children: result,
                          },
                        ];

                        const dateSelected = moment()
                          .add(30, "days")
                          .format("Y-MM-DD");

                        return (
                          <div key={index} className="col-12 col-md-3">
                            <a
                              href={
                                "/packageDetails?package_id=" +
                                Base64.btoa(id) +
                                "&name=" +
                                encodeURIComponent(start_location) +
                                "&checkin=" +
                                encodeURIComponent(start_date) +
                                "&checkout=" +
                                encodeURIComponent(end_date) +
                                "&guestCombination=" +
                                JSON.stringify(guest_combination) +
                                "&itineraryPlan=" +
                                encodeURIComponent(JSON.stringify(treeData)) +
                                "&moreLocation=" +
                                encodeURIComponent(start_location) +
                                "&dateselected=" +
                                encodeURIComponent(dateSelected) +
                                "&package_name=" +
                                encodeURIComponent(package_name)
                              }
                            >
                              <div className="card h-100 rounded-3 rounded-top shadow border text-black">
                                <LazyLoadImage
                                  src={package_image}
                                  className="card-img-top w-100"
                                  style={{
                                    minHeight: 150,
                                    objectFit: "cover",
                                  }}
                                  placeholderSrc={
                                    process.env.PUBLIC_URL +
                                    "images/placeholder.png"
                                  }
                                  key={index}
                                />
                                <span class="position-absolute btn btn-sm btn-warning align-self-end fw-bold shadow py-0">
                                  {no_days}N/{parseInt(no_days) + 1}D
                                </span>
                                <div className="card-body d-flex flex-column">
                                  <h6 className="card-title fw-bold mb-0">
                                    {package_name}
                                  </h6>
                                  <small className="d-block fw-bold text-muted mb-1">
                                    {location
                                      .map(
                                        ({ number, location }) =>
                                          `${number}N ${location}`
                                      )
                                      .join(", ")}
                                  </small>
                                  {packageDescription && (
                                    <small className="d-block fw-light my-1 fst-italic text-muted">
                                      {packageDescription +
                                        (packageDescription.length > 50
                                          ? "..."
                                          : "")}
                                    </small>
                                  )}
                                  <div className="mt-auto">
                                    <small className="d-block border-top mt-2 pt-2">
                                      <span className="fw-bold">
                                        Guest Combination:
                                      </span>{" "}
                                      {guestCombination}
                                    </small>
                                    <small className="d-block">
                                      <span className="fw-bold">
                                        Package available till
                                      </span>{" "}
                                      {moment(package_close_date).format(
                                        "ddd, D MMM yy"
                                      )}
                                    </small>
                                  </div>
                                </div>

                                <div className="card-footer bg-primary bg-opacity-10">
                                  <small className="d-block fw-bold">
                                    from
                                  </small>
                                  <div className="d-flex align-items-baseline flex-wrap gap-1">
                                    {parseFloat(discount_percentage) > 0 && (
                                      <s className="text-muted fw-bold">
                                        {constant.amountWithCurrency(price)}
                                      </s>
                                    )}
                                    <h6 className="card-title fw-bold mb-0 text-black">
                                      {constant.amountWithCurrency(
                                        selling_price
                                      )}
                                    </h6>
                                    {parseFloat(discount_percentage) > 0 && (
                                      <sup className="badge bg-danger rounded-pill fw-bold">
                                        {discount_percentage}% OFF
                                      </sup>
                                    )}
                                  </div>
                                  <small>Excluding applicable taxes</small>
                                </div>
                              </div>
                            </a>
                          </div>
                        );
                      }
                    )
                  ) : (
                    <div
                      key="no-package"
                      className="col-12"
                      style={{ minHeight: 200 }}
                    >
                      <div className="card h-100 rounded shadow-sm border d-flex justify-content-center align-items-center">
                        <p className="text-center">No packages available.</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <button
                className="btn btn-dark position-absolute top-50 translate-middle-y"
                onClick={nextSlide}
                disabled={currentIndex + itemsPerSlide >= packageData.length}
                style={{ zIndex: 10, right: -15 }}
              >
                ❯
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SliderComponent;
